<template>
  <main class="" id="app-container">
    <TopNav class="desktop-top-nav" />
    <MobileTopNavVue class="mobile-top-nav" />
    <div class="d-flex flex-row">

      <LeftNav class="desktop-left-nav" />

      <div id="content">
        <router-view />
      </div>
    </div>
  </main>
</template>

<script>
import TopNav from "@/components/navigation/TopNav.vue";
import MobileTopNavVue from './components/navigation/MobileTopNav.vue';
import LeftNav from "./components/navigation/LeftNav.vue";



export default {
  name: "App",
  components: {
    TopNav,
    LeftNav,
    MobileTopNavVue,
  },
};
</script>

<style>
#app-container {
  display: flex;
  flex-direction: column;
}

#content {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: stretch;
  width: 100%;
}




.desktop-left-nav {
  height: calc(100vh - 56px);
  -webkit-filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2));
  -moz-filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2));
  -ms-filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2));
  -o-filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2));
  filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2));
}


/* remove nav element when printed */
@media print {
  #app-container {
    overflow: auto !important;
    height: auto !important;
  }

  #content {
    height: auto !important;
  }
}

@media screen and (max-width: 768px) {
  .desktop-top-nav {
    display: none !important;
  }

  .mobile-top-nav {
    display: block !important;
  }

  .desktop-left-nav {
    display: none !important;

  }
}

@media screen and (min-width: 768px) {
  .desktop-top-nav {
    display: block !important
  }

  .mobile-top-nav {
    display: none !important;
  }

  .desktop-left-nav {
    display: block !important;
  }

  #content {
    margin-left: 300px;
  }
}
</style>
